/* eslint-disable no-undef */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

const ModalRoot = ({ rootClassName = '', ...props }) => {
  const modalRef = useRef(null); // Create a ref to track the modal element

  useEffect(() => {
    // Function to check modal presence and handle overflow
    const handleOverflow = () => {
      if (modalRef.current) {
        // Modal exists
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    };

    handleOverflow(); // Call initially

    // Event listener to update overflow when modal is added/removed
    const observer = new MutationObserver(() => handleOverflow());
    observer.observe(document.body, { childList: true });

    return () => {
      // Cleanup function to remove event listener and reset overflow
      observer.disconnect();
      document.body.style.overflow = 'auto';
    };
  }, []);

  return createPortal(
    <div ref={modalRef} className={`modal-root ${rootClassName}`}>
      {props.children}
    </div>,
    document.getElementById('modal_root')
  );
};

export default ModalRoot;

ModalRoot.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  rootClassName: PropTypes.string,
};

export { default as Modal } from './Modal';
export { default as ModalBody } from './ModalBody';
export { default as ModalHeader } from './ModalHeader';
